/*
 * ra-app.js — страница /risk-assessment-generator.
 *
 * Черновик из библиотеки собирается здесь же, без сервера (RACore). Сервер
 * зовётся только за платной работой: доработка под описание работы и версия
 * для бригады. Нажатие платной кнопки несёт ключ `rid`, незаконченный заказ
 * лежит в localStorage: ответ, оборванный сменой сети, перезагрузкой или
 * заморозкой вкладки, страница забирает по ключу и не платит дважды
 * (docs/why/paid-sync-result.md).
 *
 * Работа человека живёт в __toolDraft.editor: переживает F5, закрытую вкладку
 * и крах браузера.
 *
 * ES2018-safe, как весь public/js.
 */
(function () {
    'use strict';
    var CFG = window.__RA_CFG;
    var C = window.RACore;
    if (!CFG || !C) return;
    var I = CFG.i18n || {};
    var $ = function (id) { return document.getElementById(id); };
    var esc = C.esc;
    var PENDING_KEY = 'ra-pending-order';
    var POLL_MS = 4000, POLL_MAX_MS = 6 * 60 * 1000;

    var el = {
        format: $('raFormat'), src: $('raSrc'), docLang: $('raDocLang'), crewLang: $('raCrewLang'), crewNote: $('raCrewNote'),
        job: $('raJob'), company: $('raCompany'), site: $('raSite'), date: $('raDate'), prepared: $('raPrepared'), approved: $('raApproved'),
        works: $('raWorks'), build: $('raBuild'), ai: $('raAi'), msg: $('raMsg'),
        empty: $('raEmpty'), editor: $('raEditor'), crew: $('raCrew'), exp: $('raExport'),
        pdf: $('raPdf'), docx: $('raDocx'), print: $('raPrint'), printRoot: $('raPrintRoot'),
    };
    if (!el.format || !el.editor) return;

    var vocabs = {};
    vocabs[CFG.locale] = CFG.vocab;
    var info = null;
    var busy = false;
    var tab = 'doc';
    var ed = null;
    var open = {};
    var state = blank();

    function stage(name, meta) { try { if (window.__stage) window.__stage(name, meta || {}); } catch (e) {} }

    function today() {
        var d = new Date();
        return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }

    function blank() {
        return {
            v: 1, format: el.format.value, docLang: el.docLang.value, crewLang: el.crewLang.value,
            job: '', company: '', site: '', date: today(), prepared: '', approved: '',
            works: [], title: '', method: '', rows: [], ppe: [], ppeOther: '', permits: [], permitsOther: '',
            competency: '', plant: '', emergency: '', monitor: '', hrcw: [], crew: null, built: false, mode: '',
        };
    }

    function fmt() { return CFG.formats[state.format] || CFG.formats.intl_iso; }

    // ── словари по языку документа ──────────────────────────────────────
    function getVocab(lang) {
        if (vocabs[lang]) return Promise.resolve(vocabs[lang]);
        if (CFG.siteLangs.indexOf(lang) < 0) return Promise.resolve(null);
        return fetch(CFG.urls.vocab.replace('__L__', lang), { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) { if (j && j.doc) vocabs[lang] = j; return vocabs[lang] || null; })
            .catch(function () { return null; });
    }
    function docVocab() { return vocabs[state.docLang] || CFG.vocab; }

    // ── сообщения ───────────────────────────────────────────────────────
    function say(html, kind) {
        if (!el.msg) return;
        el.msg.innerHTML = html;
        el.msg.className = 'ra-msg tc-msg' + (kind ? ' ' + kind : '');
        el.msg.hidden = !html;
    }
    function topupLink(short) {
        if (!CFG.urls.topup) return '';
        return ' <a href="' + esc(CFG.urls.topup) + '"' + (short ? ' data-tmb-short="' + (short | 0) + '"' : '') + '>' + esc(I.topup) + '</a>';
    }
    function authLinks() {
        return ' <a href="' + esc(CFG.urls.login) + '">' + esc(I.sign_in) + '</a>' + topupLink(0);
    }

    // ── сохранение работы ───────────────────────────────────────────────
    var touchT = null;
    function touch() {
        if (!ed) return;
        clearTimeout(touchT);
        touchT = setTimeout(function () { try { ed.touch(true); } catch (e) {} }, 250);
    }

    function readHeader() {
        state.job = el.job.value;
        state.company = el.company.value;
        state.site = el.site.value;
        state.date = el.date.value;
        state.prepared = el.prepared.value;
        state.approved = el.approved.value;
    }
    function syncInputs() {
        el.format.value = state.format;
        el.docLang.value = state.docLang;
        el.crewLang.value = state.crewLang;
        el.job.value = state.job || '';
        el.company.value = state.company || '';
        el.site.value = state.site || '';
        el.date.value = state.date || '';
        el.prepared.value = state.prepared || '';
        el.approved.value = state.approved || '';
        Array.prototype.forEach.call(el.works.querySelectorAll('input'), function (i) {
            i.checked = (state.works || []).indexOf(i.value) >= 0;
        });
    }

    // ── цена доработки: документ + инструктаж, если язык бригады другой ──
    function renderCost() {
        var cost = $('raAiCost'), money = $('raAiMoney');
        if (!cost) return;
        var crew = state.crewLang !== state.docLang;
        var n = (CFG.costs.compose || 0) + (crew ? (CFG.costs.brief || 0) : 0);
        cost.textContent = crew ? I.cost_compose_crew : I.cost_compose;
        if (money) {
            money.setAttribute('data-token-cost', String(n));
            if (window.__tokenPrice && window.__tokenPrice.ready) {
                window.__tokenPrice.ready().then(function () { money.textContent = window.__tokenPrice.text(n); });
            }
        }
    }

    // ── источник формата ────────────────────────────────────────────────
    function renderSource() {
        var f = fmt();
        el.src.innerHTML = '<b>' + esc(I.src_label) + '</b> ' + (f.sources || []).map(function (s) {
            return s.url ? '<a href="' + esc(s.url) + '" target="_blank" rel="noopener">' + esc(s.title) + '</a>' : esc(s.title);
        }).join('; ');
        el.crewNote.hidden = CFG.siteLangs.indexOf(state.crewLang) >= 0;
    }

    // ── редактор ────────────────────────────────────────────────────────
    function options(list, val) {
        return list.map(function (o) {
            return '<option value="' + esc(o.v) + '"' + (String(o.v) === String(val) ? ' selected' : '') + '>' + esc(o.label) + '</option>';
        }).join('');
    }
    function badge(l, s) {
        var r = C.rate(fmt().matrix, l, s, state.docLang, docVocab());
        return '<span class="ra-badge ' + esc(r.band) + '">' + esc(r.text) + '</span>';
    }
    function levelOptions(val) {
        var d = docVocab().doc || {};
        return C.LEVELS.map(function (k) {
            return '<option value="' + k + '"' + (k === val ? ' selected' : '') + '>' + esc((d.lvl || {})[k] || k) + '</option>';
        }).join('');
    }

    function rowTools(editing) {
        return '<span class="ra-tools">'
            + (editing
                ? '<button type="button" class="ra-ib ra-ed on" data-act="edit" title="' + esc(I.row_done) + '" aria-label="' + esc(I.row_done) + '">✓</button>'
                : '<button type="button" class="ra-ib ra-ed" data-act="edit" title="' + esc(I.row_edit) + '" aria-label="' + esc(I.row_edit) + '">✎</button>')
            + '<button type="button" class="ra-ib" data-act="up" title="' + esc(I.row_up) + '" aria-label="' + esc(I.row_up) + '">↑</button>'
            + '<button type="button" class="ra-ib" data-act="down" title="' + esc(I.row_down) + '" aria-label="' + esc(I.row_down) + '">↓</button>'
            + '<button type="button" class="ra-ib" data-act="del" title="' + esc(I.row_del) + '" aria-label="' + esc(I.row_del) + '">✕</button></span>';
    }

    /* Строка в чтении — так, как она ляжет на лист: компактно, вся таблица
       видна прокруткой в пару экранов, а не в десяток. Правка — по кнопке. */
    function rowReadHtml(r, n) {
        var f = fmt(), d = docVocab().doc || {}, mx = f.matrix, cols = f.columns || [];
        var h = '<div class="ra-row ra-read" data-row="' + n + '">';
        h += '<div class="ra-row-head"><span class="ra-row-n">' + (n + 1) + '</span><div class="ra-sum">'
            + (r.step ? '<span class="ra-sum-step">' + esc(r.step) + '</span>' : '')
            + '<span class="ra-sum-hz">' + esc(r.hazard || I.ph_hazard) + '</span>'
            + (mx !== 'none' ? '<span class="ra-sum-rate">' + badge(r.l, r.s) + ' → ' + badge(r.l2, r.s2) + '</span>' : '')
            + '</div>'
            + rowTools(false) + '</div>';
        h += '<ul class="ra-rl">' + (r.controls || []).filter(function (c) { return String(c.t || '').trim(); }).map(function (c) {
            return '<li><b class="ra-lv ra-lv-' + esc(c.lvl) + '">' + esc((d.lvl || {})[c.lvl] || c.lvl) + '</b> ' + esc(c.t) + '</li>';
        }).join('') + '</ul>';
        var meta = [];
        if (cols.indexOf('who') >= 0 && (r.who || []).length) meta.push((r.who || []).map(function (k) { return (d.who || {})[k] || k; }).join(', '));
        if (r.resp) meta.push(C.colLabel(f, 'responsible', state.docLang, docVocab()) + ': ' + r.resp);
        if (r.due && cols.indexOf('due') >= 0) meta.push(C.colLabel(f, 'due', state.docLang, docVocab()) + ': ' + r.due);
        if (meta.length) h += '<p class="ra-meta">' + esc(meta.join(' · ')) + '</p>';
        return h + '</div>';
    }

    function rowHtml(r, n) {
        if (!open[r.id]) return rowReadHtml(r, n);
        var f = fmt(), d = docVocab().doc || {}, mx = f.matrix, cols = f.columns || [];
        var lS = C.scale(mx, 'l', state.docLang, docVocab()), sS = C.scale(mx, 's', state.docLang, docVocab());
        var h = '<div class="ra-row" data-row="' + n + '">';
        h += '<div class="ra-row-head"><span class="ra-row-n">' + (n + 1) + '</span>'
            + '<input class="ra-in ra-step" data-f="step" value="' + esc(r.step) + '" placeholder="' + esc(I.ph_step) + '" aria-label="' + esc(I.ph_step) + '">'
            + rowTools(true) + '</div>';
        h += '<textarea class="ra-in" data-f="hazard" rows="2" placeholder="' + esc(I.ph_hazard) + '" aria-label="' + esc(I.ph_hazard) + '">' + esc(r.hazard) + '</textarea>';
        if (cols.indexOf('who') >= 0) {
            h += '<div class="ra-who" role="group" aria-label="' + esc(I.lbl_who) + '">' + ['w', 'o', 'p'].map(function (k) {
                return '<label class="ra-chip"><input type="checkbox" data-f="who" value="' + k + '"' + ((r.who || []).indexOf(k) >= 0 ? ' checked' : '') + '><span>' + esc((d.who || {})[k] || k) + '</span></label>';
            }).join('') + '</div>';
        }
        if (mx !== 'none') {
            h += '<div class="ra-rate"><span class="ra-lbl">' + esc(I.lbl_before) + ':</span>'
                + '<select class="ra-sel" data-f="l" aria-label="' + esc(I.lbl_like) + '">' + options(lS, C.snap(mx, 'l', r.l)) + '</select>'
                + '<select class="ra-sel" data-f="s" aria-label="' + esc(I.lbl_sev) + '">' + options(sS, C.snap(mx, 's', r.s)) + '</select>'
                + '<span data-badge="before">' + badge(r.l, r.s) + '</span></div>';
        }
        h += '<div class="ra-ctls">' + (r.controls || []).map(function (c, k) {
            return '<div class="ra-ctl" data-ctl="' + k + '"><select class="ra-sel" data-f="lvl" aria-label="' + esc(I.lbl_level) + '">' + levelOptions(c.lvl) + '</select>'
                + '<textarea class="ra-in" data-f="ctl" rows="1" placeholder="' + esc(I.ph_control) + '" aria-label="' + esc(I.ph_control) + '">' + esc(c.t) + '</textarea>'
                + '<button type="button" class="ra-ib" data-act="ctl-del" title="' + esc(I.ctl_del) + '" aria-label="' + esc(I.ctl_del) + '">✕</button></div>';
        }).join('') + '<div><button type="button" class="tc-btn ghost sm" data-act="ctl-add">＋ ' + esc(I.ctl_add) + '</button></div></div>';
        if (mx !== 'none') {
            h += '<div class="ra-rate"><span class="ra-lbl">' + esc(I.lbl_after) + ':</span>'
                + '<select class="ra-sel" data-f="l2" aria-label="' + esc(I.lbl_like) + '">' + options(lS, C.snap(mx, 'l', r.l2)) + '</select>'
                + '<select class="ra-sel" data-f="s2" aria-label="' + esc(I.lbl_sev) + '">' + options(sS, C.snap(mx, 's', r.s2)) + '</select>'
                + '<span data-badge="after">' + badge(r.l2, r.s2) + '</span></div>';
        }
        h += '<div class="ra-two"><input class="ra-in" data-f="resp" value="' + esc(r.resp) + '" placeholder="' + esc(I.ph_resp) + '" aria-label="' + esc(C.colLabel(f, 'responsible', state.docLang, docVocab())) + '">';
        if (cols.indexOf('due') >= 0) {
            h += '<input class="ra-in" data-f="due" value="' + esc(r.due) + '" placeholder="' + esc(I.ph_due) + '" aria-label="' + esc(C.colLabel(f, 'due', state.docLang, docVocab())) + '">';
        }
        h += '</div></div>';
        return h;
    }

    function checks(field, ids, names, chosen) {
        return '<div class="ra-list">' + ids.map(function (k) {
            return '<label class="ra-chip"><input type="checkbox" data-sec="' + field + '" value="' + esc(k) + '"' + (chosen.indexOf(k) >= 0 ? ' checked' : '') + '><span>' + esc(names[k] || k) + '</span></label>';
        }).join('') + '</div>';
    }
    function area(field, title, val, rows) {
        return '<div class="ra-sect"><h3>' + esc(title) + '</h3><textarea class="ra-in ra-txt" data-sec="' + field + '" rows="' + (rows || 3) + '" placeholder="' + esc(I.ph_lines) + '" style="min-height:0">' + esc(val || '') + '</textarea></div>';
    }

    function renderEditor() {
        var f = fmt(), dv = docVocab(), d = dv.doc || {}, lib = dv.lib || {}, secs = f.sections || [];
        var has = function (s) { return secs.indexOf(s) >= 0; };
        var h = [];
        h.push('<div class="ra-sect"><p class="tc-hint">' + esc(I.levels_hint) + '</p></div>');
        if (has('hrcw') && f.hrcw && f.hrcw.length) {
            h.push('<div class="ra-sect"><h3>' + esc(C.secLabel(f, 'hrcw', state.docLang, dv)) + '</h3><div class="ra-list">' + f.hrcw.map(function (t, k) {
                return '<label class="ra-chip"><input type="checkbox" data-sec="hrcw" value="' + k + '"' + ((state.hrcw || []).indexOf(k) >= 0 ? ' checked' : '') + '><span>' + esc(t) + '</span></label>';
            }).join('') + '</div></div>');
        }
        if (has('method')) h.push(area('method', C.secLabel(f, 'method', state.docLang, dv), state.method, 4));
        h.push('<div class="ra-rows" id="raRows">' + state.rows.map(rowHtml).join('') + '</div>');
        h.push('<div><button type="button" class="tc-btn ghost sm" data-act="row-add">＋ ' + esc(I.row_add) + '</button></div>');
        if (has('ppe')) {
            h.push('<div class="ra-sect"><h3>' + esc(C.secLabel(f, 'ppe', state.docLang, dv)) + '</h3>'
                + checks('ppe', CFG.structure.ppe, lib.ppe || {}, state.ppe || [])
                + '<textarea class="ra-in" data-sec="ppeOther" rows="2" placeholder="' + esc(I.ph_lines) + '">' + esc(state.ppeOther || '') + '</textarea></div>');
        }
        if (has('permits')) {
            h.push('<div class="ra-sect"><h3>' + esc(C.secLabel(f, 'permits', state.docLang, dv)) + '</h3>'
                + checks('permits', CFG.structure.permits, lib.permit || {}, state.permits || [])
                + '<textarea class="ra-in" data-sec="permitsOther" rows="2" placeholder="' + esc(I.ph_lines) + '">' + esc(state.permitsOther || '') + '</textarea></div>');
        }
        if (has('competency')) h.push(area('competency', C.secLabel(f, 'competency', state.docLang, dv), state.competency, 3));
        if (has('plant')) h.push(area('plant', C.secLabel(f, 'plant', state.docLang, dv), state.plant, 3));
        if (has('emergency')) h.push(area('emergency', C.secLabel(f, 'emergency', state.docLang, dv), state.emergency, 4));
        if (has('monitor')) h.push(area('monitor', C.secLabel(f, 'monitor', state.docLang, dv), state.monitor, 3));
        el.editor.innerHTML = h.join('');
        Array.prototype.forEach.call(el.editor.querySelectorAll('textarea'), autosize);
        el.editor.setAttribute('dir', C.RTL[state.docLang] ? 'rtl' : 'ltr');
        el.editor.setAttribute('lang', state.docLang);
        void d;
    }

    function renderCrew() {
        var lang = state.crewLang;
        var cv = vocabs[lang] || null;
        var items = C.crewItems(state, cv);
        var bad = items.filter(function (x) { return !x.ok; }).length;
        var labels = (state.crew && state.crew.lang === lang && state.crew.labels) || {};
        var crew = (cv && cv.crew) || (docVocab().crew || {});
        var h = [];
        if (lang === state.docLang) h.push('<p class="tc-hint">' + esc(I.crew_same_lang) + '</p>');
        if (bad) {
            h.push('<p class="ra-msg tc-msg warn">' + esc(I.crew_untranslated) + '</p>');
            if (CFG.aiOn) {
                h.push('<p><button type="button" class="tc-btn ghost sm" id="raBrief">✨ ' + esc(I.btn_brief) + '<span class="ra-cost">· ' + esc(I.cost_brief) + '</span></button> '
                    + '<small class="tc-hint">' + esc(I.btn_brief_hint) + '</small></p>');
            }
        }
        h.push('<h3 style="margin:8px 0 6px;font-size:15px">' + esc(labels.title || crew.title || '') + '</h3>');
        h.push('<table><thead><tr><th>#</th><th>' + esc(labels.hazard || crew.hazard || '') + '</th><th>' + esc(labels.do || crew.do || '') + '</th></tr></thead><tbody>');
        items.forEach(function (it, n) {
            h.push('<tr><td>' + (n + 1) + '</td><td>' + (it.ok ? '' : '<span class="ra-warn" title="' + esc(I.crew_untranslated) + '">⚠</span> ') + esc(it.hazard) + '</td><td>' + esc(it.do) + '</td></tr>');
        });
        h.push('</tbody></table>');
        h.push('<p style="font-weight:700;margin-top:10px">' + esc(labels.stop || crew.stop || '') + '</p>');
        el.crew.innerHTML = h.join('');
        el.crew.setAttribute('dir', C.RTL[lang] ? 'rtl' : 'ltr');
        el.crew.setAttribute('lang', lang);
        var b = $('raBrief');
        if (b) b.addEventListener('click', brief);
    }

    function renderAll() {
        renderSource();
        renderCost();
        var built = state.built && state.rows.length > 0;
        el.empty.hidden = built;
        el.exp.hidden = !built;
        el.editor.hidden = !built || tab !== 'doc';
        el.crew.hidden = !built || tab !== 'crew';
        el.build.textContent = state.built ? I.btn_rebuild : I.btn_build;
        if (!built) return;
        if (tab === 'doc') renderEditor();
        else renderCrew();
    }

    function setTab(t) {
        tab = t;
        Array.prototype.forEach.call(document.querySelectorAll('[data-ra-tab]'), function (b) {
            var on = b.getAttribute('data-ra-tab') === t;
            b.classList.toggle('on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (t === 'crew') {
            getVocab(state.crewLang).then(function () { renderAll(); });
        } else {
            renderAll();
        }
    }

    // ── правка документа ────────────────────────────────────────────────
    function autosize(t) {
        t.style.height = 'auto';
        t.style.height = (t.scrollHeight + 2) + 'px';
    }

    function rowOf(t) {
        var box = t.closest('[data-row]');
        return box ? { box: box, i: +box.getAttribute('data-row') } : null;
    }

    el.editor.addEventListener('input', function (e) {
        var t = e.target;
        if (t.tagName === 'TEXTAREA') autosize(t);
        var sec = t.getAttribute('data-sec');
        if (sec) {
            if (t.type === 'checkbox') return;
            state[sec] = t.value;
            touch();
            return;
        }
        var ro = rowOf(t);
        if (!ro) return;
        var r = state.rows[ro.i];
        var f = t.getAttribute('data-f');
        if (f === 'step') { r.step = t.value; r.stepLib = false; }
        else if (f === 'hazard') { r.hazard = t.value; delete r.hk; }
        else if (f === 'resp') r.resp = t.value;
        else if (f === 'due') r.due = t.value;
        else if (f === 'ctl') {
            var k = +t.closest('[data-ctl]').getAttribute('data-ctl');
            r.controls[k].t = t.value;
            delete r.controls[k].k;
        }
        touch();
    });

    el.editor.addEventListener('change', function (e) {
        var t = e.target;
        var sec = t.getAttribute('data-sec');
        if (sec && t.type === 'checkbox') {
            var arr = state[sec] || [];
            var v = sec === 'hrcw' ? +t.value : t.value;
            var at = arr.indexOf(v);
            if (t.checked && at < 0) arr.push(v);
            if (!t.checked && at >= 0) arr.splice(at, 1);
            state[sec] = arr;
            touch();
            return;
        }
        var ro = rowOf(t);
        if (!ro) return;
        var r = state.rows[ro.i];
        var f = t.getAttribute('data-f');
        if (f === 'who') {
            r.who = Array.prototype.map.call(ro.box.querySelectorAll('input[data-f="who"]:checked'), function (x) { return x.value; });
        } else if (f === 'l' || f === 's' || f === 'l2' || f === 's2') {
            r[f] = +t.value;
            var bb = ro.box.querySelector('[data-badge="before"]'), ba = ro.box.querySelector('[data-badge="after"]');
            if (bb) bb.innerHTML = badge(r.l, r.s);
            if (ba) ba.innerHTML = badge(r.l2, r.s2);
        } else if (f === 'lvl') {
            var k = +t.closest('[data-ctl]').getAttribute('data-ctl');
            r.controls[k].lvl = t.value;
        }
        touch();
    });

    el.editor.addEventListener('click', function (e) {
        var b = e.target.closest('[data-act]');
        if (!b) return;
        var act = b.getAttribute('data-act');
        if (act === 'row-add') {
            var nr = { id: C.uid(), src: 'user', step: '', hazard: '', who: ['w'], l: 3, s: 3, l2: 2, s2: 3, controls: [{ lvl: 'A', t: '' }], resp: '', due: '' };
            state.rows.push(nr);
            open[nr.id] = true;
            renderAll();
            var rows = el.editor.querySelectorAll('[data-row]');
            var last = rows[rows.length - 1];
            if (last) {
                last.scrollIntoView({ block: 'nearest' });
                var inp = last.querySelector('[data-f="step"]');
                if (inp) inp.focus();
            }
            touch();
            return;
        }
        var ro = rowOf(b);
        if (!ro) return;
        var r = state.rows[ro.i];
        if (act === 'edit') {
            open[r.id] = !open[r.id];
            renderAll();
            var box = el.editor.querySelector('[data-row="' + ro.i + '"]');
            if (box) {
                box.scrollIntoView({ block: 'nearest' });
                var first = open[r.id] ? box.querySelector('[data-f="hazard"]') : box.querySelector('[data-act="edit"]');
                if (first) first.focus();
            }
            return;
        }
        if (act === 'del') state.rows.splice(ro.i, 1);
        else if (act === 'up' && ro.i > 0) state.rows.splice(ro.i - 1, 0, state.rows.splice(ro.i, 1)[0]);
        else if (act === 'down' && ro.i < state.rows.length - 1) state.rows.splice(ro.i + 1, 0, state.rows.splice(ro.i, 1)[0]);
        else if (act === 'ctl-add') r.controls.push({ lvl: 'A', t: '' });
        else if (act === 'ctl-del') {
            var k = +b.closest('[data-ctl]').getAttribute('data-ctl');
            r.controls.splice(k, 1);
        } else return;
        renderAll();
        touch();
    });

    // ── черновик из библиотеки ──────────────────────────────────────────
    // Виды работ → категории высокорискованных работ SWMS (Model WHS Regs r 291).
    var HRCW_BY_WORK = { height: [0], scaffold: [0], roof: [0], demolition: [2], confined: [5], excavation: [6], electrical: [10], road: [13], plant: [14], lifting: [14] };

    function buildLibrary() {
        readHeader();
        if (!state.works.length) { say(esc(I.err_works), 'warn'); return; }
        if (state.built && state.rows.length && !window.confirm(I.rebuild_confirm)) return;
        getVocab(state.docLang).then(function (v) {
            v = v || CFG.vocab;
            var b = C.buildFromLibrary(state.works, CFG.structure, v);
            open = {};
            state.rows = b.rows;
            state.ppe = b.ppe;
            state.permits = b.permits;
            state.crew = null;
            fillDefaults(v);
            if (fmt().hrcw && fmt().hrcw.length) {
                var set = {};
                state.works.forEach(function (w) { (HRCW_BY_WORK[w] || []).forEach(function (k) { set[k] = 1; }); });
                state.hrcw = Object.keys(set).map(Number);
            }
            state.built = true;
            state.mode = 'lib';
            say('', '');
            renderAll();
            touch();
            stage('draft_built', { mode: 'lib', rows: state.rows.length, format: state.format });
            try { if (window.__aeToolComplete) window.__aeToolComplete({ mode: 'lib', rows: state.rows.length, format: state.format }); } catch (e) {}
        });
    }

    function fillDefaults(v) {
        var d = (v && v.doc) || {};
        if (!String(state.emergency || '').trim()) state.emergency = d.emergency_default || '';
        if (!String(state.monitor || '').trim()) state.monitor = d.monitor_default || '';
    }

    // ── платные лейны ───────────────────────────────────────────────────
    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }
    function newRid() {
        var a = new Uint8Array(12);
        (window.crypto || window.msCrypto).getRandomValues(a);
        return Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    }
    function savePending(p) { try { localStorage.setItem(PENDING_KEY, JSON.stringify(p)); } catch (e) {} }
    function readPending() {
        try {
            var p = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
            return p && p.rid && Date.now() - (p.at || 0) < 2 * 3600 * 1000 ? p : null;
        } catch (e) { return null; }
    }
    function clearPending() { try { localStorage.removeItem(PENDING_KEY); } catch (e) {} }

    function setBusy(on) {
        busy = on;
        if (el.ai) el.ai.disabled = on;
        el.build.disabled = on;
        var b = $('raBrief');
        if (b) b.disabled = on;
    }

    function post(url, body) {
        var ctl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = ctl ? setTimeout(function () { ctl.abort(); }, CFG.waitMs || 125000) : null;
        return fetch(url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined,
        }).then(function (r) {
            return r.json().then(function (j) { return { status: r.status, json: j }; }, function () { return { status: r.status, json: null }; });
        }, function () { return { status: 0, json: null }; }).finally(function () { if (timer) clearTimeout(timer); });
    }

    function loadInfo() {
        if (info) return Promise.resolve(info);
        return fetch(CFG.urls.info + '?locale=' + encodeURIComponent(CFG.locale), { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) { info = j; return j; })
            .catch(function () { return null; });
    }

    function compose() {
        if (busy) return;
        readHeader();
        if (String(state.job || '').trim().length < 12) { say(esc(I.err_short), 'warn'); el.job.focus(); return; }
        loadInfo().then(function (inf) {
            if (inf && !inf.enabled) { say(esc(I.err_disabled), 'warn'); return; }
            if (inf && !inf.logged_in) { say(esc(I.err_auth) + authLinks(), 'warn'); return; }
            var p = { op: 'compose', rid: newRid(), at: Date.now() };
            savePending(p);
            setBusy(true);
            say(esc(I.ai_working), '');
            stage('ai_start', { op: 'compose', format: state.format });
            post(CFG.urls.compose, {
                rid: p.rid, format: state.format, doc_lang: state.docLang, crew_lang: state.crewLang,
                job: state.job, works: state.works,
                known: state.rows.slice(0, 20).map(function (r) { return r.hazard; }).filter(Boolean),
            }).then(function (res) { handle(p, res, Date.now()); });
        });
    }

    function brief(auto) {
        if (busy) return;
        var cv = vocabs[state.crewLang] || null;
        var items = C.crewItems(state, cv);
        var rows = [], hashes = [];
        state.rows.forEach(function (r, i) {
            if (items[i] && !items[i].ok && String(r.hazard || '').trim()) {
                rows.push({ hazard: r.hazard, controls: (r.controls || []).map(function (c) { return c.t; }).filter(Boolean) });
                hashes.push(C.rowHash(r));
            }
        });
        if (!rows.length) return;
        loadInfo().then(function (inf) {
            if (inf && !inf.logged_in) { say(esc(I.err_auth) + authLinks(), 'warn'); setTab('doc'); return; }
            var p = { op: 'brief', rid: newRid(), at: Date.now(), hashes: hashes, lang: state.crewLang, prior: auto ? (el.msg.innerHTML || '') : '' };
            savePending(p);
            setBusy(true);
            say((p.prior ? p.prior + ' ' : '') + esc(I.brief_working), '');
            stage('ai_start', { op: 'brief', lang: state.crewLang });
            post(CFG.urls.brief, { rid: p.rid, format: state.format, doc_lang: state.docLang, crew_lang: state.crewLang, rows: rows })
                .then(function (res) { handle(p, res, Date.now()); });
        });
    }

    function handle(p, res, started) {
        var j = res.json || {};
        if (res.status === 200 && j.ok) { finish(p, j); return; }
        if (res.status === 202) { poll(p, started); return; }
        // Без статуса, не JSON или 5xx края — обрыв, а не провал: заказ мог
        // уже строиться и списаться, поэтому спрашиваем о нём по ключу.
        if (res.status === 0 || (!res.json && res.status >= 500) || res.status === 504) {
            say(esc(I.ai_lost), '');
            poll(p, started);
            return;
        }
        clearPending();
        setBusy(false);
        var e = j.error || '';
        if (res.status === 402) say(esc(I.err_tokens) + topupLink(j.short || j.need || 0), 'warn');
        else if (res.status === 401) say(esc(I.err_auth) + authLinks(), 'warn');
        else if (res.status === 429) say(esc(I.err_throttled), 'warn');
        else if (res.status === 503) say(esc(I.err_disabled), 'warn');
        else if (e === 'short') say(esc(I.err_short), 'warn');
        else if (e === 'blocked') say(esc(I.err_blocked), 'bad');
        else if (e === 'nothing') say(esc(I.err_nothing), 'warn');
        else say(esc(I.err_failed), 'bad');
        stage('ai_fail', { op: p.op, status: res.status, error: e });
    }

    function poll(p, started) {
        if (Date.now() - started > POLL_MAX_MS) {
            clearPending(); setBusy(false); say(esc(I.err_failed), 'bad');
            return;
        }
        setTimeout(function () {
            var url = CFG.urls.order.replace('__OP__', p.op).replace('__RID__', p.rid);
            fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json().then(function (j) { return { status: r.status, json: j }; }, function () { return { status: r.status, json: null }; }); },
                    function () { return { status: 0, json: null }; })
                .then(function (res) {
                    if (res.status === 200 && res.json && res.json.ok) finish(p, res.json);
                    else if (res.status === 202 || res.status === 0 || res.status >= 500) poll(p, started);
                    else { clearPending(); setBusy(false); say(esc(I.err_failed), 'bad'); }
                });
        }, POLL_MS);
    }

    function finish(p, j) {
        clearPending();
        setBusy(false);
        if (p.op === 'compose' && j.doc) applyCompose(j);
        if (p.op === 'brief' && j.crew) applyBrief(p, j.crew);
        // Забранный по ключу заказ тоже называет списание: человек, у которого
        // оборвался ответ, иначе так и не узнает, что за документ заплачено.
        var charged = j.charged ? ' ' + esc(String(I.charged_tpl || '').replace('__N__', j.charged)) : '';
        var prior = p.prior ? p.prior + ' ' : '';
        if (p.op === 'brief' && j.crew_failed) say(prior + esc(I.brief_done) + charged + ' ' + esc(I.crew_failed), 'warn');
        else say(prior + esc(p.op === 'brief' ? I.brief_done : I.ai_done) + charged, 'good');
        touch();
        // Бригада на другом языке — инструктаж заказывается следом, тем же
        // нажатием (его цена была на кнопке).
        if (p.op === 'compose' && state.crewLang !== state.docLang && CFG.aiOn) {
            getVocab(state.crewLang).then(function () { brief(true); });
        }
    }

    function applyCompose(j) {
        var d = j.doc;
        state.rows = (d.rows || []).map(function (r) {
            return { id: C.uid(), src: 'ai', step: r.step || '', hazard: r.hazard || '', who: r.who || [], l: r.l, s: r.s, l2: r.l2, s2: r.s2,
                controls: (r.controls || []).map(function (c) { return { lvl: c.lvl, t: c.t }; }), resp: r.resp || '', due: r.due || '' };
        });
        state.title = d.title || state.title;
        state.method = (d.method || []).join('\n');
        state.ppe = [];
        state.ppeOther = (d.ppe || []).join('\n');
        state.permits = [];
        state.permitsOther = (d.permits || []).join('\n');
        state.competency = (d.competency || []).join('\n');
        state.plant = (d.plant || []).join('\n');
        state.emergency = d.emergency || '';
        state.monitor = '';
        if (fmt().hrcw && fmt().hrcw.length) state.hrcw = d.hrcw || [];
        state.crew = null;
        getVocab(state.docLang).then(function (v) {
            fillDefaults(v || CFG.vocab);
            state.built = true;
            state.mode = 'ai';
            renderAll();
            touch();
            stage('draft_built', { mode: 'ai', rows: state.rows.length, format: state.format });
            try { if (window.__aeToolComplete) window.__aeToolComplete({ mode: 'ai', rows: state.rows.length, format: state.format }); } catch (e) {}
        });
    }

    function applyBrief(p, crew) {
        var prev = (state.crew && state.crew.lang === crew.lang) ? state.crew : { lang: crew.lang, items: [], ppe: '', labels: {} };
        var have = {};
        prev.items.forEach(function (it) { have[it.h] = it; });
        (crew.items || []).forEach(function (it, i) {
            var h = (p.hashes || [])[typeof it.row === 'number' ? it.row : i];
            if (h) have[h] = { h: h, hazard: it.hazard, do: it.do };
        });
        state.crew = {
            lang: crew.lang, ppe: crew.ppe || prev.ppe, labels: Object.keys(crew.labels || {}).length ? crew.labels : prev.labels,
            items: Object.keys(have).map(function (k) { return have[k]; }),
        };
        renderAll();
    }

    // ── выдача ──────────────────────────────────────────────────────────
    function fileBase() {
        var name = (fmt().short || 'risk-assessment') + ' ' + (state.title || state.job || '').slice(0, 50);
        var s = window.__outputName && window.__outputName.sanitize ? window.__outputName.sanitize(name) : name.replace(/[\\/:*?"<>|\n\r\t]+/g, ' ');
        return String(s).trim().replace(/\s+/g, ' ') || 'risk-assessment';
    }

    function printableHtml() {
        readHeader();
        return getVocab(state.crewLang).then(function (cv) {
            return C.printable({
                state: state, fmt: fmt(), docVocab: docVocab(), crewVocab: cv,
                crewLabels: (state.crew && state.crew.lang === state.crewLang && state.crew.labels) || {},
                disclaimer: I.disclaimer,
            });
        });
    }

    function exported(kind) {
        try { if (ed) ed.exported(); } catch (e) {}
        stage('export', { kind: kind, rows: state.rows.length });
    }

    el.pdf.addEventListener('click', function () {
        if (typeof window.__generatePDF !== 'function') { say(esc(I.pdf_failed), 'bad'); return; }
        var label = el.pdf.textContent;
        el.pdf.disabled = true;
        el.pdf.textContent = I.pdf_working;
        printableHtml().then(function (html) {
            var node = document.createElement('div');
            node.className = 'rap';
            // Направление отчёта — языка документа, а не страницы: дверь PDF
            // рисует слова в направлении узла (арабский документ на /ru/ — rtl).
            node.setAttribute('dir', C.RTL[state.docLang] ? 'rtl' : 'ltr');
            node.innerHTML = html;
            return window.__generatePDF({
                element: node, filename: fileBase() + '.pdf', orientation: 'landscape',
                pagebreak: { mode: ['css', 'legacy'], avoid: ['tr', '.rap-avoid', 'h2'] }, strings: { genError: I.pdf_failed },
            });
        }).then(function (r) {
            if (r && r.ok) exported('pdf');
            else if (r && !r.ok) say(esc(I.pdf_failed), 'bad');
        }).catch(function () { say(esc(I.pdf_failed), 'bad'); })
            .finally(function () { el.pdf.disabled = false; el.pdf.textContent = label; });
    });

    el.docx.addEventListener('click', function () {
        if (!window.DocxWriter || typeof window.__downloadFile !== 'function') return;
        readHeader();
        var tag = { pt: 'pt-BR', es: 'es-419', en: 'en-US', ko: 'ko-KR', ar: 'ar-SA', id: 'id-ID', de: 'de-DE', fr: 'fr-FR', ru: 'ru-RU', uk: 'uk-UA' };
        getVocab(state.crewLang).then(function (cv) {
            return window.DocxWriter.build({
                docTitle: fmt().title, font: 'Arial', size: 20, line: 276, lang: tag[state.docLang] || state.docLang,
                blocks: C.docxBlocks({
                    state: state, fmt: fmt(), docVocab: docVocab(), crewVocab: cv, disclaimer: I.disclaimer,
                    crewLabels: (state.crew && state.crew.lang === state.crewLang && state.crew.labels) || {},
                }),
            });
        }).then(function (blob) {
            return window.__downloadFile(blob, fileBase() + '.docx');
        }).then(function (ok) { if (ok !== false) exported('docx'); })
            .catch(function (e) {
                if (window.__handleError) window.__handleError(e, 'risk_docx', { say: I.pdf_failed });
            });
    });

    el.print.addEventListener('click', function () {
        printableHtml().then(function (html) {
            el.printRoot.innerHTML = html;
            exported('print');
            window.print();
        });
    });

    // ── поля и переключатели ────────────────────────────────────────────
    el.format.addEventListener('change', function () {
        state.format = el.format.value;
        var f = fmt();
        // Документ ещё не собран — язык документа подстраивается под формат:
        // немецкая GBU пишется по-немецки. Собранный документ язык не меняет.
        if (!state.built && CFG.siteLangs.indexOf(f.lang) >= 0 && state.docLang !== f.lang) {
            state.docLang = f.lang;
            el.docLang.value = f.lang;
            getVocab(f.lang).then(renderAll);
        }
        renderAll();
        touch();
    });
    el.docLang.addEventListener('change', function () {
        var lang = el.docLang.value;
        var old = docVocab();
        getVocab(lang).then(function (v) {
            state.docLang = lang;
            if (v) {
                state.rows = state.rows.map(function (r) { return r.src === 'lib' ? C.retext(r, v) : r; });
                var od = (old && old.doc) || {}, nd = v.doc || {};
                if (state.emergency === od.emergency_default) state.emergency = nd.emergency_default;
                if (state.monitor === od.monitor_default) state.monitor = nd.monitor_default;
            }
            renderAll();
            touch();
        });
    });
    el.crewLang.addEventListener('change', function () {
        state.crewLang = el.crewLang.value;
        renderSource();
        getVocab(state.crewLang).then(function () { renderAll(); });
        touch();
    });
    ['job', 'company', 'site', 'date', 'prepared', 'approved'].forEach(function (k) {
        el[k].addEventListener('input', function () { readHeader(); touch(); });
    });
    el.works.addEventListener('change', function () {
        state.works = Array.prototype.map.call(el.works.querySelectorAll('input:checked'), function (i) { return i.value; });
        touch();
    });
    el.build.addEventListener('click', buildLibrary);
    if (el.ai) el.ai.addEventListener('click', compose);
    Array.prototype.forEach.call(document.querySelectorAll('[data-ra-tab]'), function (b) {
        b.addEventListener('click', function () { setTab(b.getAttribute('data-ra-tab')); });
    });

    // ── работа переживает вкладку ───────────────────────────────────────
    function boot() {
        var done = Promise.resolve();
        if (window.__toolDraft && window.__toolDraft.editor && $('raDrafts')) {
            ed = window.__toolDraft.editor({
                slug: CFG.slug, root: 'raDrafts', icon: '📋', openKey: 'ra-draft-open',
                payload: function () {
                    if (!state.built && !String(state.job || '').trim()) return null;
                    return { state: JSON.parse(JSON.stringify(state)), label: state.title || String(state.job || '').slice(0, 60) || fmt().short };
                },
                apply: function (d) {
                    var s = (d && d.state) || {};
                    state = Object.assign(blank(), s);
                    if (!CFG.formats[state.format]) state.format = el.format.value;
                    syncInputs();
                    return getVocab(state.docLang).then(function () { renderAll(); return []; });
                },
                fresh: function () {
                    state = blank();
                    syncInputs();
                    say('', '');
                    renderAll();
                },
                started: function () { return !!(state.built || String(state.job || '').trim()); },
            });
            done = ed.boot();
        }
        Promise.resolve(done).then(function () {
            if (!el.date.value) el.date.value = state.date || today();
            readHeader();
            renderAll();
            loadInfo().then(function (inf) {
                // Формат по стране — только тому, кто ещё ничего не начал: выбор
                // человека и сохранённая работа старше догадки по адресу.
                if (inf && inf.format && CFG.formats[inf.format] && !state.built && !String(state.job || '').trim() && inf.format !== state.format) {
                    state.format = inf.format;
                    el.format.value = inf.format;
                    renderAll();
                }
                var p = readPending();
                if (p && inf && inf.logged_in) {
                    setBusy(true);
                    say(esc(I.ai_lost), '');
                    poll(p, Date.now());
                }
            });
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();
